// @flow

import React, {Component} from 'react'
import {map} from 'ramda'
import './radio-select.css'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import {RadioOption, Language} from '@/types'

type Props = {
  l: Language,
  label: string,
  options: Array<RadioOption>,
  checked: string,
  onChange: (string) => void,
  disable?: boolean,
}

export class RawRadioSelect extends Component<Props> {
  renderOption = (option: RadioOption) =>
    <div className="radio" key={option.name}>
      <label className={this.props.disable ? 'disable' : ''}>
        <input
          type="radio"
          name={this.props.label}
          checked={option.value ? (this.props.checked === option.value) : (this.props.checked === option.name)}
          value={option.value || option.name}
          onChange={(e) => this.props.onChange(e.currentTarget.value)}
          disabled={(this.props.disable || option.disabled)}
        />
        {this.props.l(option.name)}
      </label>
    </div>

  render = () =>
    <div>
      <label>
        {this.props.l(this.props.label)}
        {map(this.renderOption, this.props.options)}
      </label>
    </div>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawRadioSelect)



// WEBPACK FOOTER //
// ./src/controls/radio-select.js